import {} from '@rocicorp/zero';
import { createPatch } from 'rfc6902';
import { uuidv7 } from 'uuidv7';
import { zql } from '../../schema.js';
import { assertIsAuthenticated, EventLogs } from '../../utils.js';
import { addEventLog, EventLogResources } from '../util.js';
/**
 * Resolves the display name for a therapy sequence medicine from the drug catalog
 * (prescribed name takes precedence over the active substance's catalog item name).
 */
export async function resolveMedicationName(tx, medicine) {
    if (medicine.prescribedNameId) {
        const prescribedName = await tx.run(zql.prescribedNames.where('id', '=', medicine.prescribedNameId).one());
        if (prescribedName?.name)
            return prescribedName.name;
    }
    if (medicine.activeSubstanceId) {
        const item = await tx.run(zql.drugCatalogItems.where('id', '=', medicine.activeSubstanceId).one());
        if (item?.name)
            return item.name;
    }
    return '';
}
export async function createTherapySequence(tx, input, ctx) {
    assertIsAuthenticated(ctx);
    const now = Date.now();
    const userId = ctx.user.id;
    const id = uuidv7();
    const sequence = {
        // explicit defaults: Zero cannot rely on the database defaults (CY-353)
        prescriptionSource: 'cypro',
        restVialCreated: false,
        ...input.data,
        id,
        createdAt: now,
        createdBy: userId,
    };
    await tx.mutate.patientTherapySequence.insert(sequence);
    const medicines = await Promise.all((input.medicines ?? []).map(async (medicine) => {
        const row = Object.assign({}, medicine, {
            id: uuidv7(),
            therapySequenceId: id,
            createdAt: now,
            createdBy: userId,
        });
        await tx.mutate.patientTherapySequenceMedicine.insert(row);
        return row;
    }));
    if (tx.location === 'server') {
        await addEventLog(tx, {
            id: uuidv7(),
            resource: EventLogResources.patientTherapySequence,
            resourceId: id,
            action: 'create',
            domain: 'prescription',
            event: input.log?.event ?? EventLogs.PATIENT_THERAPY_SEQUENCE_ADDED,
            patches: createPatch({}, sequence),
            performedBy: userId,
            performedAt: now,
            details: input.log?.details,
        });
    }
    return { id, internalId: input.data.internalId, sequence, medicines, now };
}
//# sourceMappingURL=therapy-sequence.js.map